import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const TOP_SCROLL_OPTIONS = Object.freeze({ top: 0, left: 0, behavior: "auto" });

function readHashId(hash) {
  if (!hash || hash === "#") return "";

  try {
    return decodeURIComponent(hash.slice(1));
  } catch {
    return hash.slice(1);
  }
}

export default function RouteScrollManager() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    const previousRestoration = window.history.scrollRestoration;
    window.history.scrollRestoration = "manual";

    return () => {
      window.history.scrollRestoration = previousRestoration;
    };
  }, []);

  useEffect(() => {
    window.scrollTo(TOP_SCROLL_OPTIONS);

    const hashId = readHashId(hash);
    if (!hashId) return undefined;

    let attempts = 0;
    let retryTimer;
    const scrollToHashTarget = () => {
      const target = document.getElementById(hashId);
      if (target) {
        target.scrollIntoView({ block: "start", behavior: "auto" });
        return;
      }

      attempts += 1;
      if (attempts < 20) {
        retryTimer = window.setTimeout(scrollToHashTarget, 50);
      }
    };

    scrollToHashTarget();
    return () => window.clearTimeout(retryTimer);
  }, [hash, pathname]);

  return null;
}
